import React from 'react';

import { StepsBannerArrows, Modal, Icon } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';

import { SelectPayment } from '../../../components/payments/selectPaymentPanel/selectPaymentPanel';
import { SELECT_PAYMENT, ENTER_CREDIT_CARD, SUMMARY } from '../../../constants/constants';
import { EnterCreditCardDetails } from '../../../components/payments/enterCreditCardDetails/enterCreditCardDetails';
import { PaymentSummary } from '../../../components/payments/summaryPage/summary';
import { usePayment } from './usePayment';
import './payment.scss';

export const Payment = () => {
  const {
    isPopupShowing,
    onClose,
    onBackToDashboard,
    activeStep,
    isLegacyPaymentEnabled,
    paymentDetails,
    handleCancelButton,
    paymentResponseObj,
    handleMakeAnotherPaymentButton,
    handleUpdateBankDetails
  } = usePayment();

  return (
    <main aria-label="Important Message Popup">
      {isPopupShowing && (
        <Modal
          customCssClass="importantMessagePopup"
          size="small"
          isContentScrollable
          showFooterDivider
          showCloseIconButton={false}
          open
          onClose={onClose}
          header={
            <h2 className="modal-title">
              <Icon icon="warning" /> Important Message
            </h2>
          }
          footer={
            <button
              onClick={() => onBackToDashboard()}
              type="button"
              className="button primary nextButton"
            >
              <span>Back to dashboard</span>
            </button>
          }
        >
          <section className="importantMessageSection">
            {/* eslint-disable-next-line max-len */}
            <b>Our Pay Now feature is currently unavailable.</b>
            <p>Thanks for your patience as we work to get it back online.</p>
            {/* eslint-disable-next-line max-len */}
            <p>
              Please try again later, or if you would like to make a payment now, contact our customer service team.
            </p>
          </section>
        </Modal>
      )}
      <h1 className="mainPageHeader">Premiums &amp; payments</h1>
      <h2>Pay now</h2>
      <StepsBannerArrows
        customCssClass="step-banner-mobile"
        steps={[
          {
            label: 'SELECT PAYMENT',
            isActive: activeStep === 1
          },
          {
            label: 'ENTER CARD DETAILS',
            isActive: activeStep === 2
          },
          {
            label: 'SUMMARY',
            isActive: activeStep === 3
          }
        ]}
      />

      {activeStep === SELECT_PAYMENT && (
        <>
          {!isLegacyPaymentEnabled && (
            <div className="pleaseNoteMessage">
              <span>
                <b>Note:</b> Once you select <strong>Next</strong>, you’ll be securely redirected to our payment
                provider to enter your payment details and process your payment. Once payment is complete, you will be
                securely redirected back to your Pet Portal. Please do not close or refresh your browser.
              </span>
            </div>
          )}
          <SelectPayment />
        </>
      )}
      {activeStep === ENTER_CREDIT_CARD && paymentDetails && paymentDetails?.PremiumInstallment && (
        <EnterCreditCardDetails
          instalmentToPay={paymentDetails}
          onCancelButton={handleCancelButton}
        />
      )}
      {activeStep === SUMMARY && paymentResponseObj && paymentResponseObj?.TotalAmount && (
        <PaymentSummary
          paymentResponse={paymentResponseObj}
          onMakeAnotherPayment={handleMakeAnotherPaymentButton}
          onUpdateBankDetails={handleUpdateBankDetails}
        />
      )}
    </main>
  );
};
